import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import CaseStudies from "@/pages/CaseStudies";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/industries" element={<Layout><Industries /></Layout>} />
          <Route path="/case-studies" element={<Layout><CaseStudies /></Layout>} />
          <Route path="/careers" element={<Layout><Careers /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="*" element={<Layout><Seo title="Page not found" description="This page could not be found on ERAM DIGITAL." noindex /><section className="mx-auto max-w-7xl px-6 py-24" data-testid="not-found-page"><p className="text-sm font-semibold text-brand-violet">404 — Page not found</p><h1 className="mt-5 font-display text-4xl font-bold sm:text-5xl">Let's get you back on track.</h1><p className="mt-5 text-slate-600">This page doesn't exist. Explore ERAM DIGITAL's services or return to the home page.</p><div className="mt-8 flex gap-5"><Link to="/" className="rounded-full gradient-bg px-6 py-3 text-sm font-semibold text-white" data-testid="not-found-home">Back to home</Link><Link to="/services" className="px-4 py-3 text-sm font-semibold" data-testid="not-found-services">Explore services</Link></div></section></Layout>} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
